import { Colors, WorkspaceSizeThresholds } from "@/common/constants";
import { interactionBarShadow } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		flexShrink: 0,
		backgroundColor: tokens.colorNeutralBackground1,
		minHeight: "60px",
		...shorthands.overflow("hidden"),
		margin: "0 1rem 0",
		...shorthands.borderRadius(tokens.borderRadiusMedium),
		...interactionBarShadow(),
		flexDirection: "row",

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				flexDirection: "column",
			},
	},
	leftContainer: {
		padding: "5px 16px 10px 16px",
		flexGrow: 1,
		...shorthands.overflow("hidden"),
		width: "100%",

		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				alignSelf: "flex-start",
			},
	},
	rightContainer: {
		width: "100%",
		padding: "16px 16px 10px 16px",
		justifyContent: "flex-end",
		...shorthands.overflow("hidden"),
	},
	icon: {
		marginLeft: "6px",
		color: tokens.colorNeutralForeground3,
		flexShrink: 0,
		marginRight: "4px",
	},
	divider: {
		flexGrow: 0,
		[`@container workspacePanel (width <= ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				display: "none",
			},
	},
	// Same green and label colour as the Pickup button — see the fuller note beside the matching
	// initCallButton in outboundVoiceInteraction/style.ts. White comes from Fluent's
	// appearance="primary" on Pickup, and its ~2.5:1 on #6BB700 is a property of the brand green
	// rather than of this button, so the two stay in step until the green itself changes.
	initCallButton: {
		...shorthands.border(0),
		backgroundColor: Colors.ButtonGreenBackground,
		borderRadius: tokens.borderRadiusMedium,
		color: tokens.colorNeutralForegroundOnBrand,
		minHeight: "32px",
		minWidth: "48px",
		cursor: "pointer",
		width: "100%",

		":disabled": {
			backgroundColor: tokens.colorNeutralStroke1Hover,
		},
		":disabled:hover": {
			backgroundColor: tokens.colorNeutralStroke1,
			cursor: "default",
		},
		"&:hover": {
			backgroundColor: Colors.ButtonGreenBackgroundHover,
		},
		"&:active": {
			backgroundColor: Colors.ButtonGreenBackgroundHover,
		},
	},
	contactLabel: {
		maxWidth: "98%",
	},
	closeButton: {
		position: "absolute",
		top: "9px",
		right: "12px",
	},
	multiInput: {
		width: "100%",
	},
	multiInputContainer: {
		width: "100%",
		padding: "6px 0px 0px 6px",
		backgroundColor: tokens.colorNeutralBackground1Hover,
	},
	selectContainer: {
		width: "100%",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		padding: "3px 6px",
	},
	multiInputElement: {
		width: "100%",
		backgroundColor: tokens.colorNeutralBackground1Hover,
		"&:focus-within": {
			outline: "none",
			boxShadow: "none",
		},
	},
	mailButtonContainer: {
		width: "100%",
		padding: "0px 16px 20px 16px",
	},
	mailButtonIcon: {
		marginRight: "6px",
	},
	selectTrigger: {
		width: "100%",
		[`@container workspacePanel (width > ${WorkspaceSizeThresholds.Medium}px)`]:
			{
				maxWidth: "unset !important",
			},
	},
	menuPopoverOutbound: {
		overflowY: "scroll",
		maxWidth: "unset",
		width: "400px",
		maxHeight: "calc(100vh - 200px)",
	},
});
